import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import { Truck, RotateCcw, Clock, Shield } from 'lucide-react';

const DeliveryReturn = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="font-heading text-4xl mb-2">
            {t('legal.deliveryReturn.title', 'Teslimat ve Iade Sartlari')}
          </h1>
          <p className="text-muted-foreground mb-8">
            {t('legal.deliveryReturn.lastUpdate', 'Son guncelleme: 26 Mart 2026')}
          </p>

          <div className="space-y-8 text-foreground/90 leading-relaxed">

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Truck className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-heading text-2xl">
                  {t('legal.deliveryReturn.delivery.title', '1. Hizmet Teslimat Bilgileri')}
                </h2>
              </div>
              <div className="pl-13 space-y-3">
                <p>{t('legal.deliveryReturn.delivery.p1', 'InkTrack, dijital bir platform olup fiziksel urun teslimati yapmamaktadir. Satin alinan premium abonelik planlari, odeme islemi tamamlandiktan sonra aninda aktif hale gelir.')}</p>
                <p>{t('legal.deliveryReturn.delivery.p2', 'Premium ozelliklere erisim, odemenin onaylanmasindan itibaren 24 saat icinde hesabiniza tanimlanir. Herhangi bir gecikme durumunda destek ekibimize ulasabilirsiniz.')}</p>
                <p>{t('legal.deliveryReturn.delivery.p3', 'Abonelik suresi boyunca tum premium ozellikler kesintisiz olarak kullanilabilir.')}</p>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <RotateCcw className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-heading text-2xl">
                  {t('legal.deliveryReturn.refund.title', '2. Iade ve Iptal Kosullari')}
                </h2>
              </div>
              <div className="pl-13 space-y-3">
                <p>{t('legal.deliveryReturn.refund.p1', 'Aylik abonelikler: Satin alma tarihinden itibaren 14 gun icinde iade talep edebilirsiniz. Bu sure icinde hizmet kullanilmamissa tam iade yapilir.')}</p>
                <p>{t('legal.deliveryReturn.refund.p2', 'Yillik abonelikler: Ilk 30 gun icinde iade talep edebilirsiniz. Kullanilan sure oraninda kesinti yapilarak kalan tutar iade edilir.')}</p>
                <p>{t('legal.deliveryReturn.refund.p3', 'Iade talepleri info@ink-track.com adresine e-posta gondererek yapilabilir. Iade islemleri 5-10 is gunu icinde tamamlanir.')}</p>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Clock className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-heading text-2xl">
                  {t('legal.deliveryReturn.cancellation.title', '3. Abonelik Iptali')}
                </h2>
              </div>
              <div className="pl-13 space-y-3">
                <p>{t('legal.deliveryReturn.cancellation.p1', 'Aboneliginizi istediginiz zaman iptal edebilirsiniz. Iptal islemi sonrasinda mevcut abonelik suresi sonuna kadar premium ozellikleri kullanmaya devam edebilirsiniz.')}</p>
                <p>{t('legal.deliveryReturn.cancellation.p2', 'Otomatik yenileme, iptal isleminin ardindan durdurulur ve bir sonraki donemde ucret alinmaz.')}</p>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Shield className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-heading text-2xl">
                  {t('legal.deliveryReturn.contact.title', '4. Iletisim')}
                </h2>
              </div>
              <div className="pl-13 space-y-3">
                <p>{t('legal.deliveryReturn.contact.p1', 'Teslimat veya iade ile ilgili sorulariniz icin:')}</p>
                <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                  <li>E-posta: info@ink-track.com</li>
                  <li>{t('legal.deliveryReturn.contact.response', 'Yanit suresi: 1-3 is gunu')}</li>
                </ul>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default DeliveryReturn;
